export default __webpack_public_path__ + "static/media/elab-1.08c3231d.png";